<template>
	<div>
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="cpf" name="cpf" type="text" v-model='usu.cpf' required>
				<label for="cpf" class='active'>CPF</label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="email" name="email" type="text"  v-model='usu.email' required>
				<label for="email" class='active'>e-mail</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="name" name="name" type="text"  v-model='usu.name' required>
				<label for="name" class='active'>Nome</label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="nome_social" name="nome_social" type="text"  v-model='usu.nome_social' required>
				<label for="nome_social" class='active'>Nome social</label>
			</div>
		</div>
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="sira" name="sira" type="text"  v-model='usu.bolsista.sira' required>
				<label for="sira" class='active'>DRE</label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="curso" name="curso" type="text"  v-model='usu.bolsista.curso' required>
				<label for="curso" class='active'>Curso</label>
			</div>
		</div>
		
		<div class="row">
			<div class="input-field col s12 m6 l6 xl6">
				<input readonly id="lattes" name="lattes" type="text"  v-model='usu.lattes' required>
				<label for="lattes" class='active'>ID do Lattes</label>
			</div>
			<div class="input-field col s12 m6 l6 xl6">
				<select name="cancelamento" required class="browser-default select_sec">
					<option value="" disabled selected>Motivo do cancelamento</option>
					<option v-for="can in this.cans" :value="can.id">{{ can.codigo }} - {{ can.descricao }}</option>
				</select>
			</div>
		</div>
	
		<div class="row">
			<div class="input-field col s6 m3 l3 xl3">
				<button type="submit" class="btn" onclick="return confirmarRemover();">
					<i class="material-icons left">remove</i>
				Remover</button>
			</div>
			<div class="input-field col s6 m3 l3 xl3">
				<button type="button" class="btn indigo" onclick="window.history.back();">
					<i class="material-icons right">clear</i>
						Cancelar</button>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
		name: "VueBolsaRemocaoForm",
		props: [
			'relatorio',
			'cancelamentos'
		],
		data() {
			return {
				usu: JSON.parse(this.relatorio).aluno,
				cans: JSON.parse(this.cancelamentos)
			}
		},
		computed: {
		},
		methods: {
		},
		mounted: function() {
			if (!this.usu.lattes)
				this.usu.lattes = ' ';
		}
    }
</script>
